export default {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  height: '25vh'
}
